import axios from 'axios';

export namespace api {
    export function IsUnauthorized(err: any) {
        // Semantically this actually means "not authenticated". See explanation here:
        // https://stackoverflow.com/questions/3297048/403-forbidden-vs-401-unauthorized-http-responses
        return axios.isAxiosError(err) && err.response?.status === 401;
    }

    export class User {
        constructor(
            readonly id: string,
            readonly name: string,
            readonly email: string,
            readonly picture: string,
            readonly username: string
        ) {}
    }

    export async function GetLoggedInUser() {
        try {
            const r = await axios.get<User>('/api/whoami');
            return r.data;
        } catch (err) {
            console.error(`authenticating: ${err}`);
            return null;
        }
    }

    // These structs capture the expected shape of the data after calling
    // JSON.parse().
    namespace raw {
        export interface PublicSSHKey {
            readonly fingerprint: string;
            readonly key: string;
            readonly name: string;
            readonly expiration_time_usec: number;
            readonly retain_until_time_usec: number;
        }
    }

    export class PublicSSHKey {
        constructor(
            readonly fingerprint: string,
            readonly name: string,
            readonly publicKey: string,
            readonly expirationTimeUsec: number,
            readonly retainUntilTimeUsec: number
        ) {}

        static fromJSON(payload: raw.PublicSSHKey) {
            return new PublicSSHKey(
                payload.fingerprint,
                payload.name,
                payload.key,
                payload.expiration_time_usec,
                payload.retain_until_time_usec
            );
        }
    }

    export async function ListPublicSSHKeys(username: string, expired: boolean = true) {
        const r = await axios.get<raw.PublicSSHKey[]>(
            `/api/user/${username}/keys`,
            expired ? { params: { expired: true } } : {}
        );
        return r.data.map((k) => PublicSSHKey.fromJSON(k));
    }

    export async function AddPublicSSHKey(username: string, key: string) {
        return axios.post(`/api/user/${username}/key`, { public_key: key });
    }

    export async function DeletePublicSSHKey(username: string, fingerprint: string) {
        return axios.delete(`/api/user/${username}/key/${fingerprint}`);
    }

    export async function RenewPublicSSHKey(username: string, fingerprint: string) {
        return axios.post(`/api/user/${username}/key/${fingerprint}/renew`);
    }
}

export default api;
